import { render, staticRenderFns } from "./NewCustomer.vue?vue&type=template&id=2115dd91&scoped=true&"
import script from "./NewCustomer.vue?vue&type=script&lang=ts&"
export * from "./NewCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./NewCustomer.vue?vue&type=style&index=0&id=2115dd91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115dd91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VAlert,VBtn,VIcon,VSheet,VStepper,VStepperContent,VStepperStep})
